import React, { Component } from 'react';


export default class OrderEditHeader extends Component {
  render() {
    const {
      order,
      deliveryDate: {
        value: deliveryDateValue,
        error: deliveryDateError,
      },
      handleOrderSubmit,
      handleDeliveryDateChange
    } = this.props;
    return (
    <div className="order-detail-edit-header">
      <div className="d-flex justify-content-between align-items-center">
        <div className="title">
          <h4>Order #{order.id}</h4>
        </div>
        <button className="btn btn-primary m-0" onClick={handleOrderSubmit}>
          Send order
        </button>
      </div>
      <div className={`${deliveryDateError ? 'has-danger order-delivery-date' : 'order-delivery-date'}`}>
        <label htmlFor="delivery-date" className="col-form-label">Delivery Date</label>
        <input
          className="form-control col-sm-4"
          type="date"
          id="delivery-date"
          value={deliveryDateValue}
          onChange={handleDeliveryDateChange}
        />
        {deliveryDateError && (
          <small className="error form-control-feedback">The delivery date cannot be in the past</small>
        )}
      </div>
      <div className="card-block p-0 pt-2 reports-filter">
        <h3>Item filters</h3>
        <form className="d-flex p-0">
          <div className='col-sm-4 form-group m-0 p-0 mr-3'>
            <label className="col-sm-12 col-form-label pl-0 filter-label" htmlFor="searchQuery">
              <i className="fa fa-search mr-05 ml-05" />
              Search
            </label>
            <input
              type="text"
              id="searchQuery"
              name="searchQuery"
              placeholder="Search items"
              onChange={this.props.onSearchQueryChanged}
              value={this.props.searchQuery}
              className="form-control col-sm-12"
            />
          </div>
          <div className='col-sm-4 form-group m-0 p-0 mr-3'>
            <label className="col-sm-12 col-form-label pl-0 filter-label" htmlFor="station">
              <i className="fa fa-store mr-05 ml-05" />
              Station
            </label>
            <div className="col-sm-12 pl-0">
              <select
                id="station"
                name="station"
                className="form-control"
                value={this.props.station}
                onChange={this.props.onStationChanged}
              >
                <option value={-1}>Select station</option>
                {this.props.stationOptions ? (
                  this.props.stationOptions.map((station,index) => {
                    return(
                      <option
                        value={index}
                        label={station.name}
                        key={station.id}
                      >
                        {station.name
                      }</option>
                    )
                  })) : <option value=" ">Loading...</option>
                }
              </select>
            </div>
          </div>
        </form>
      </div>
    </div>
    );
  }
}
